import _ from "lodash";
import {LOGO_IMAGE_DETAIL} from "../constants/shopify.constant";

export {
    processLogoDetails,
}

const processLogoDetails = (settings) => {
    if (settings && (_.isEmpty(settings.logo) || !_.isNaN(settings.logo.width) || _.isNaN(settings.logo.height))) {
        settings.logo = LOGO_IMAGE_DETAIL.logo;
    }

    prepareLogoPosition(settings);
}

const prepareLogoPosition = (settings) => {
    const imageHeight = settings.logo.height;
    const imageWidth = settings.logo.width;
    const defaultX = 10;
    const defaultY = 10;

    let positionX;
    let positionY;

    switch (settings.positionType) {
        case 'left-top':
            positionX = defaultX;
            positionY = defaultY;
            break;
        case 'left-center':
            positionX = defaultX;
            positionY = (settings?.height / 2) - (imageHeight / 2);
            break;
        case 'left-bottom':
            positionX = defaultX;
            positionY = settings?.height - (imageHeight + defaultY);
            break;
        case 'right-top':
            positionX = settings?.width - (imageWidth + defaultX);
            positionY = defaultY;
            break;
        case 'right-center':
            positionX = settings?.width - (imageWidth + defaultX);
            positionY = (settings?.height / 2) - (imageHeight / 2);
            break;
        case 'right-bottom':
            positionX = settings?.width - (imageWidth + defaultX);
            positionY = settings?.height - (imageHeight + defaultY);
            break;
        case 'center-top':
            positionX = (settings?.width / 2) - (imageWidth / 2);
            positionY = defaultY;
            break;
        case 'center-center':
            positionX = (settings?.width / 2) - (imageWidth / 2);
            positionY = (settings?.height / 2) - (imageHeight / 2);
            break;
        case 'center-bottom':
            positionX = (settings?.width / 2) - (imageWidth / 2);
            positionY = settings?.height - (imageHeight + defaultY);
            break;
        default:
            positionX = defaultX;
            positionY = defaultY;
    }

    settings.logo.x = positionX;
    settings.logo.y = positionY;
}

